import { ApartmentOutlined } from "@ant-design/icons";
import { ReactComponent as FileUploadIcon } from "../../../assets/svgIcon/shipment/FileUpload.svg";
import { ReactComponent as NotesIcon } from "../../../assets/svgIcon/shipment/Notes.svg";

export function BoardCardIcons({ order, onOpenFiles, onOpenNotes, onOpenGraph }) {
  return (
    <div className="btnGroup" draggable={false}>
      <span
        className={` ${order.is_file_available ? "iconInBoat" : ""} iconWrapper`}
        title={order.is_file_available ? "Files attached" : "Upload files"}
        role="button"
        aria-label={order.is_file_available ? "Files attached" : "Upload files"}
        onClick={() =>
          onOpenFiles(
            order.id,
            order.name,
            order.user_reference?.trim() || order.reference?.trim() || "",
          )
        }
      >
        <FileUploadIcon className="fileUploadCardIcon" />
      </span>
      <span
        className={` ${order.open_task_count > 0 ? "iconInBoat" : ""} iconWrapper`}
        title={order.open_task_count > 0 ? `Tasks (${order.open_task_count} pending)` : "Tasks"}
        aria-label={order.open_task_count > 0 ? `Tasks (${order.open_task_count} pending)` : "Tasks"}
        role="button"
        onClick={() =>
          onOpenNotes(order.id, order.name, order.is_note_available, order.open_task_count)
        }
      >
        <NotesIcon />{" "}
      </span>
      {onOpenGraph ? (
        <span
          className="iconWrapper"
          title="Relationship graph"
          aria-label="Relationship graph"
          role="button"
          onClick={() => onOpenGraph(order.id, order.name)}
        >
          <ApartmentOutlined style={{ fontSize: 16 }} />
        </span>
      ) : null}
    </div>
  );
}
